// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth_tmQAr{padding:80px 10px 10px;display:flex;width:100%}@media only screen and (min-width:450px){.auth_tmQAr{padding:105px 30px 35px}}@media only screen and (min-width:800px){.auth_tmQAr{padding:130px 40px 50px}}@media only screen and (min-width:1150px){.auth_tmQAr{padding:130px 60px 50px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"auth": "auth_tmQAr"
};
module.exports = ___CSS_LOADER_EXPORT___;
